import React from "react";
import blading from "../images/blade2.jpg";
import backcup from "../images/backcup2.jpg";

export default class Appointments extends React.Component {
  render() {
    return (
      <>
        <div className="appt">
          <section className="appointments-hero">
            <svg
              className="appointments-branch appointments-branch-left"
              viewBox="0 0 260 190"
              aria-hidden="true"
            >
              <path d="M0 170C62 128 119 80 220 20" />
              <path d="M45 139C25 111 28 79 46 54C65 82 64 111 45 139Z" />
              <path d="M91 104C73 76 80 46 102 24C117 55 111 82 91 104Z" />
              <path d="M132 77C123 50 136 27 162 12C168 40 156 64 132 77Z" />
              <path d="M69 122C88 92 116 83 145 91C125 116 98 129 69 122Z" />
              <path d="M120 85C143 61 170 58 197 70C174 91 148 97 120 85Z" />
            </svg>

            <div className="appointments-content">
              <header className="appointments-heading">
                <h1>Appointments</h1>

                <div className="appointments-title-accent" aria-hidden="true">
                  <span />

                  <svg viewBox="0 0 28 22">
                    <path d="M14 20C13 12 8 7 2 3C3 12 7 18 14 20Z" />
                    <path d="M14 20C15 12 20 7 26 3C25 12 21 18 14 20Z" />
                  </svg>

                  <span />
                </div>
              </header>

              {/* <aside className="new-client-notice">
                <svg
                  className="new-client-icon"
                  viewBox="0 0 48 48"
                  aria-hidden="true"
                >
                  <rect x="9" y="8" width="27" height="34" rx="3" />
                  <path d="M17 8V5.5C17 4.1 18.1 3 19.5 3h6C26.9 3 28 4.1 28 5.5V8" />
                  <path d="M17 26l5 5 9-11" />
                  <path d="M31 39c1.5-5 5.5-8 11-8-1 5.5-4.5 9-11 8Z" />
                  <path d="M31 39c-1-4-3.5-6.5-7-8 0 4.5 2 7.5 7 8Z" />
                </svg>

                <p>
                  New clients must complete the form before booking appointments
                </p>
              </aside> */}
            </div>

            <svg
              className="appointments-branch appointments-branch-right"
              viewBox="0 0 260 190"
              aria-hidden="true"
            >
              <path d="M0 170C62 128 119 80 220 20" />
              <path d="M45 139C25 111 28 79 46 54C65 82 64 111 45 139Z" />
              <path d="M91 104C73 76 80 46 102 24C117 55 111 82 91 104Z" />
              <path d="M132 77C123 50 136 27 162 12C168 40 156 64 132 77Z" />
              <path d="M69 122C88 92 116 83 145 91C125 116 98 129 69 122Z" />
              <path d="M120 85C143 61 170 58 197 70C174 91 148 97 120 85Z" />
            </svg>
          </section>

          <section className="appointment-policy-grid">
            <div className="appointment-policy-card cancellation-policy-card">
              <h2>Cancellation Policy</h2>
              <p>
                If you have an upcoming appointment, please notify your
                therapist 24 hours before your scheduled appointment for any
                cancellations. If you arrive more than 10 minutes late for your
                service, we may not be able to accommodate you and we will
                charge a cancellation fee of the full service.
                <br></br>
                <br></br>Please respect your massage therapist and your
                scheduled time. Any missed appointments, no shows or
                cancellations (within the 24 hours) are subject to 100% charge
                of the session. After three cancellations (within the 24 hour
                window) and/or no shows, we will no longer be able to service
                you. Thank you for your understanding.
              </p>
            </div>

            <div className="appointment-policy-card policy-dark zero-tolerance-card">
              <h2>Restore Massage & Bodywork Zero Tolerance Policy</h2>

              <p className="policy-intro">
                Restore Massage & Bodywork is a professional therapeutic
                practice. To ensure a safe, respectful, and ethical environment
                for both clients and practitioner, the following Zero Tolerance
                Policy is strictly upheld:
              </p>

              <div className="policy-rule">
                <h3>
                  Any form of sexual language, innuendo, solicitation, or
                  inappropriate behavior is not permitted.
                </h3>
                <p>
                  This includes verbal comments, gestures, requests, or actions
                  that are sexual in nature or violate professional boundaries.
                </p>
              </div>

              <div className="policy-rule">
                <h3>
                  Bodywork and massage therapy are strictly non-sexual services.
                </h3>
                <p>
                  Any attempt to shift the session toward sexual intent will
                  result in the immediate termination of the appointment.
                </p>
              </div>

              <div className="policy-rule">
                <h3>
                  The session will end immediately if inappropriate behavior
                  occurs.
                </h3>
                <p>
                  Payment for the full session will still be required, and the
                  client will be permanently dismissed from the practice.
                </p>
              </div>

              <div className="policy-rule">
                <h3>
                  Respect for personal and professional boundaries is expected
                  at all times.
                </h3>
                <p>
                  Clients must communicate respectfully, follow draping
                  guidelines, and honor the therapeutic nature of the work.
                </p>
              </div>

              <div className="policy-rule">
                <h3>Safety is the top priority.</h3>
                <p>
                  This policy exists to protect the integrity of the therapeutic
                  relationship and ensure a safe, comfortable environment for
                  healing and recovery.
                </p>
              </div>

              <p className="policy-agreement">
                By booking a session at Restore Massage & Bodywork, clients
                agree to uphold these standards and participate in a
                professional, respectful therapeutic experience.
              </p>
            </div>
          </section>
        </div>

        <div className="row">
          {/* <div className="card">
            <img src={blading} alt="blading" />
            <div className="card-body">
              <h5>Existing Clients</h5>
              <button
                type="button"
                className="btn"
                data-toggle="modal"
                data-target="#appointment"
              >
                Book an Appointment
              </button> */}
          {/* ------------------Modal--------------- */}
          {/* <div
                className="modal fade"
                id="appointment"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalCenterTitle">
                        Booking an Appointment
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body"></div>
                    <p>
                      Is this your first time visiting? <br />
                      Are you a <b>NEW</b> client?
                    </p>
                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        type="button"
                        id="appt-modal"
                      >
                        <a
                          href="https://forms.office.com/Pages/ResponsePage.aspx?id=HLL39TyF4kOpSQMQssnEsRgU7hBnhSBKgQZZx1w59_lURU9BRUtHS09GVDlLOUdZSUpIUVpEUVZNQyQlQCN0PWcu"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Yes, I am a NEW client.
                        </a>
                      </button>
                      <button
                        className="btn btn-secondary"
                        type="button"
                        id="appt-modal"
                      >
                        <a
                          href="https://square.site/book/S3JQTRESFMDNN/restore-massage-bodywork-san-antonio-tx"
                          target="_blank"
                          rel="noreferrer"
                        >
                          I am not new, I'm ready to book an appointment.
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="card">
            <img src={backcup} alt="blading" />
            <div className="card-body">
              <h5>New Clients</h5>
              <button
                type="button"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href =
                    "https://forms.office.com/Pages/ResponsePage.aspx?id=HLL39TyF4kOpSQMQssnEsRgU7hBnhSBKgQZZx1w59_lURU9BRUtHS09GVDlLOUdZSUpIUVpEUVZNQyQlQCN0PWcu";
                }}
              >
                Please complete the new client form before booking appointments.
              </button>
            </div>
          </div> */}

          <section className="appointment-cta-section">
            <div className="appointment-cta-grid">
              <article className="appointment-cta-card">
                <img src={blading} alt="Bodywork session" />

                <div className="appointment-cta-body">
                  <a
                    className="appointment-cta-button"
                    href="https://square.site/book/S3JQTRESFMDNN/restore-massage-bodywork-san-antonio-tx"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Book your appointment with Restore
                  </a>
                </div>
              </article>

              <article className="appointment-cta-card">
                <img src={backcup} alt="Cupping therapy session" />

                <div className="appointment-cta-body">
                  <a
                    className="appointment-cta-button"
                    href="https://squareup.com/customer-programs/enroll/AzHDfVXxQZom?utm_medium=copied-link&utm_source=online"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Sign up for our email list to receive updates and promotions
                    from Restore Massage & Bodywork
                  </a>
                </div>
              </article>
            </div>
          </section>
        </div>
      </>
    );
  }
}
